import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import FormSectionTitle from '@src/components/Form/FormSectionTitle'
import { useTabs, ASSSTabs, getTabsByType } from '@src/components/Tabs/useTabs'
import TabsComp, { Tab } from '@src/components/Tabs/Tabs'
import { ProjectTypeId } from '@src/types/ProjectTypeId'
import TabsWrapper from '@src/modules/SiteResoureRequirements/comps/TabsWrapper'
import { useDRS } from '../../useDRS'
import CompDRSSubcontractorGeneralAssets from './parts/GeneralAssets'
import CompDRSSubcontractorProfilingAssets from './parts/ProfilingAssets'
import CompDRSSubcontractorTransportDelivery from './parts/TransportDelivery'
import CompDRSSubcontractorTransportProfiling from './parts/TransportProfiling'

interface Props {}

const PartDRSSubcontractors = (props: Props) => {
  const [ tabIndex, tabs, handleTabChange, setTabs ] = useTabs(ASSSTabs)
  const { drs } = useDRS()
  useEffect(() => {
    if (drs !== null) {
      setTabs(getTabsByType(drs.jobDetails.drsProjectType.id))
    }
  }, [drs])
  
  const renderAsOrSS = () => {
    const currentTab: Tab = tabs[tabIndex]
    if (currentTab.key === ProjectTypeId.Asphalt) {
      return <React.Fragment>
        <CompDRSSubcontractorGeneralAssets projectTypeId={ProjectTypeId.Asphalt}/>
        <CompDRSSubcontractorProfilingAssets />
        <CompDRSSubcontractorTransportDelivery projectTypeId={ProjectTypeId.Asphalt}/>
        <CompDRSSubcontractorTransportProfiling />
      </React.Fragment>
    } else {
      return <React.Fragment>
        <CompDRSSubcontractorGeneralAssets projectTypeId={ProjectTypeId.SpraySeal}/>
        <CompDRSSubcontractorTransportDelivery projectTypeId={ProjectTypeId.SpraySeal}/>
      </React.Fragment>
    }
  }

  return <Wrapper>
    <FormSectionTitle>SUBCONTRACTOR ASSETS</FormSectionTitle>
    <TabsWrapper>
      <TabsComp 
        tabs={tabs} 
        activeIndex={tabIndex}
        onChange={handleTabChange}
      />
    </TabsWrapper>
    { renderAsOrSS() }
  </Wrapper>
}

const Wrapper = styled.div`

`
export default PartDRSSubcontractors